import { createLevelStates as e } from "./navState.js";
import { useEffect as t, useState as n } from "react";
//#region src/components/Header/useNavLevels.ts
var r = (r, i, a) => {
	let [o, s] = n(() => e(r, i));
	return t(() => {
		s(e(r, i));
	}, [
		r,
		i,
		a
	]), [
		o,
		s,
		o.some((e) => e.levelIndex === 1 && e.isActive && e.hasContent)
	];
};
//#endregion
export { r as useNavLevels };
